module.exports = __webpack_public_path__ + "static/multiChargers-8b7836a6168e1872c914a6fedf6d62a1.png";